import Department from "./Department";

import {
    useOrders,
    toggleDepartment,
    searchByFamily, 
    setOrderSearchFamily,
  } from "../../context/orders/OrdersState";
import { div } from "react-dom-factories";
import { isMobile } from "react-device-detect";
  
  const Departments = ({closeMenu = null}) => {
    const [ordersState, ordersDispatch] = useOrders();
    const {departments, currentOrder, relevantDeps, families, relevantFamilies} = ordersState;

    console.log(departments)

    // close all departments
  const closeDepartments = (resetFamily = true) => {
    departments.map((department) => {
        if (department.open === 1) {
            department.open = 0;
            toggleDepartment(ordersDispatch, department);   
        }
        return false;
    })

    // get all products and reset family filter only if resetFamily is true
    if (resetFamily) {
      searchByFamily(ordersDispatch, currentOrder.fields.id);    
      // set no family
      setOrderSearchFamily(ordersDispatch, 0)
    }
  }

  const handleClose = () => {
    if (closeMenu) {
        closeMenu();
    }
}

    return(
      <div className={isMobile ? 'full-screen-menu card departments' : 'card departments'}>
        <div className="card_wrapper">
          <div className="card_title" onClick={() => closeDepartments(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20.862"
              height="20.918"
              viewBox="0 0 20.862 20.918"
            >
              <g
                id="Group_130"
                data-name="Group 130"
                transform="translate(71.509 -3.494)"
              >
                <g
                  id="Group_131"
                  data-name="Group 131"
                  transform="translate(-70.606 4.394)"
                >
                  <path
                    id="Path_64"
                    data-name="Path 64"
                    d="M22,17a2.9,2.9,0,0,1-3.041,3.041A2.9,2.9,0,0,1,15.914,17"
                    transform="translate(-9.434 -10.048)"
                    fill="none"
                    stroke="#bad564"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.8"
                  />
                  <path
                    id="Path_65"
                    data-name="Path 65"
                    d="M13.563,7.735a3.259,3.259,0,0,0,6.467.575,2.366,2.366,0,0,0-.06-1L18.342,1H3.135L1.128,7.424A2.413,2.413,0,0,0,1.078,8.8a3.149,3.149,0,0,0,3.144,2.2A3.259,3.259,0,0,0,7.48,7.735"
                    transform="translate(-1 -1)"
                    fill="none"
                    stroke="#bad564"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.8"
                  />
                  <path
                    id="Path_66"
                    data-name="Path 66"
                    d="M20.508,27v5.214A2.607,2.607,0,0,1,17.9,34.821H7.473a2.607,2.607,0,0,1-2.607-2.607V27"
                    transform="translate(-3.186 -15.703)"
                    fill="none"
                    stroke="#bad564"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.8"
                  />
                  <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M21.555,27v4.345h-8.69V27"
                    transform="translate(-7.71 -15.703)"
                    fill="none"
                    stroke="#bad564"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.8"
                  />
                </g>
              </g>
            </svg>
            המחלקות שלנו
          </div>
          {isMobile && 
            <i class="fa fa-times close-menu" aria-hidden="true" onClick={handleClose}></i>}

          <div className="all_departments" >
            {departments
              .filter((d) => relevantDeps?.includes(d.id + ""))
              .map((department) => (
                  <Department
                    allDepartments={departments}
                    key={department.id}
                    department={department}
                    families={families.filter(
                      (family) =>
                        +family.department_id === department.id &&
                        relevantFamilies?.includes(family.id + "")
                    )}
                    closeMenu={handleClose}
                    closeDepartments={closeDepartments}
                  />
              ))}
          </div>
        </div>
      </div>
    )
}

export default Departments;